import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storageSession from 'redux-persist/lib/storage/session';
import userReducer from './reducers/userReducer';
import subscriptionReducer from './reducers/subscriptionReducer';
import authReducer from './reducers/authReducer';
import serviceReducer from './reducers/serviceReducer';
import activityReducer from './reducers/activityReducer';
import projectReducer from './reducers/projectReducer';
import dashboardReducer from './reducers/dashboardReducer';
import likeReducer from './reducers/likeReducer';
import matchReducer from './reducers/matchReducer';
import dislikeReducer from './reducers/dislikeReducer';
import subscriptionOfferReducer from './reducers/subscriptionOfferReducer';
import propositionReducer from './reducers/propositionReducer';
import onlineReducer from './reducers/onlineReducer';
import typingReducer from './reducers/typingReducer';
import callReducer from './reducers/callReducer';
import notificationReducer from './reducers/notificationReducer';
import profilReducer from './reducers/profilReducer';
import { RESET_ALL } from "./actions/resetActions";
import caReducer from './reducers/caReducer';
import projetClientReducer from './reducers/projetClientReducer';
import interventionReducer from './reducers/interventionReducer';

const appReducer = combineReducers({
    user: userReducer, // Gestion des appels
    subscription: subscriptionReducer,
    auth: authReducer,
    service: serviceReducer,
    activity: activityReducer,
    project: projectReducer,
    dashboard: dashboardReducer,
    like: likeReducer,
    dislike: dislikeReducer,
    match: matchReducer,
    subscriptionOffer: subscriptionOfferReducer,
    proposition: propositionReducer,
    online: onlineReducer,
    typing: typingReducer,
    call: callReducer,
    notification: notificationReducer,
    profil: profilReducer,
    ca: caReducer,
    projetClient: projetClientReducer,
    intervention: interventionReducer,

});

// RESET GLOBAL
const rootReducer = (state, action) => {
    if (action.type === RESET_ALL) {
        state = undefined; // reset total Redux + persist
    }
    return appReducer(state, action);
};


const persistConfig = {
    key: "root",
    storage : storageSession ,
    blacklist: ['call'], // <--- call ne sera pas persisté

};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});
const persistor = persistStore(store);
export { persistor }
